module.exports = {"id":"221919","name":"Arber Zeneli","rating":"73","photo":"./data/images/photos/4/221919.png","club":{"name":"sc Heerenveen","logo":"./data/images/clubs/scHeerenveen.png"},"positions":["AG","AD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArberZeneli0.json
// module id = 456
// module chunks = 0